import { render } from "./TopHowToUse.vue?vue&type=template&id=191cf3de&scoped=true&ts=true"
import script from "./TopHowToUse.vue?vue&type=script&lang=ts"
export * from "./TopHowToUse.vue?vue&type=script&lang=ts"

import "./TopHowToUse.vue?vue&type=style&index=0&id=191cf3de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191cf3de"]])

export default __exports__